import React, { PureComponent } from 'react'
import moment from 'moment'

import ListItem from './parts/ListItem'
import ResultsFilterbar from './parts/ResultsFilterbar'
import { isEmbedded } from './actionsReducers'

class Results extends PureComponent {
  render() {
    const filterRadius = this.props.radiusData
    var ListItems = this.props.events.items
    .filter(item => !!item.visibleOnMap)
    .map((listitem, index) => {
      return (
        <ListItem
          // required props
          key={index}
          index={index}
          activeState={this.props.activeEventItem === index ? true : false}
          publicState={listitem.publicState}
          sport={listitem.mapIconSport}
          name={listitem.name}
          date={moment(listitem['date-from']).format('DD.MM.YYYY')}
          until={moment(listitem['date-to']).format('DD.MM.YYYY')}
          attendees={listitem.attendee}
          contests={listitem.contests}
          distance={filterRadius ? listitem.distance : false}
          courses={listitem.courses}
          street={listitem.street}
          zip={listitem.zip}
          location={listitem.location}
          state={listitem.state}
          premium={listitem.premium}
          larasch={listitem.larasch}
          //onClick={() => this.props.getActiveEvent(index, [listitem.latitude, listitem.longitude])}
          onClick={() => this.props.getActiveEvent(index, { lat: listitem.latitude, lng: listitem.longitude + 0.005 })}
        />
      )
    })

    return (
      <div className={ 'results-con' + (this.props.isVisible ? ' visible' : '') + (isEmbedded() ? ' isEmbedded' : '')}>
        <div className="results-header">
          <span>Events</span>
          <span className="count-badge">{this.props.events.items.length}</span>
        </div>
        <div className="results-subheader">
          <ResultsFilterbar setFiltersData={this.props.getFiltersData} premiumOn={this.props.premiumOn} />
        </div>
        <div className="results-list">{ListItems}</div>
      </div>
    )
  }
}

export default Results



// WEBPACK FOOTER //
// ./src/components/Results.js